import { Fragment, useEffect, useState } from "react";
import { XIcon } from "../../components/icons";
import AddDrafts from "../../pages/AddDrafts/AddDrafts";
import EntityConstants from "../../configs/EntityConstants";
import { GET } from "../../service/CRUDService";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export default function AddTemplateModal({
  isOpen,
  onClose,
  programmeId,
  programmeName,
  batchId,
  batchName: batchNameProp,
  onTemplateAdded,
}) {
  const { t } = useTranslation();

  const [batchName, setBatchName] = useState("");

  const fetchBatchName = () => {
    GET(EntityConstants.GET_BATCH_NAME)
      .then((response) => response.json())
      .then((data) => {
        if (data.batch_display_name) {
          setBatchName(data.batch_display_name);
        }
      })
      .catch((error) => {
        console.error("Error fetching batch name:", error);
      });
  };

  useEffect(() => {
    fetchBatchName();
  }, []);

  if (!isOpen) return null;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60 backdrop-blur-md" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                id="add-template-modal"
                className="w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all"
              >
                <div className="bg-white rounded-xl w-full max-h-[90vh] flex flex-col relative">
                  {/* Header */}
                  <div className="p-4 border-b flex justify-between items-center">
                    <div>
                      <h2 className="text-cfHeadingText text-lg font-semibold">
                        {t("workspace:add_certificates")}
                      </h2>
                      <p className="text-sm font-medium text-cfIssuedCredentialTemplateCardDescriptionText">
                        {t("workspace:add_certificates_description")}{" "}
                        {batchName ? batchName : t("workspace:batch")}.
                      </p>
                    </div>
                    <button
                      onClick={onClose}
                      id="add-template-modal-close"
                      aria-label={t("workspace:close")}
                      className="p-1 rounded-full hover:bg-gray-100 focus:outline-none"
                    >
                      <XIcon size={20} className="inline-flex" aria-hidden />
                    </button>
                  </div>
                  <div className="flex-1 overflow-y-auto">
                    <AddDrafts
                      programmeId={programmeId}
                      programmeName={programmeName}
                      batchId={batchId}
                      batchName={batchNameProp}
                      onClose={() => {
                        onClose();
                        onTemplateAdded();
                      }}
                    />
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
